import { api } from '../core';

export interface DocumentGetDownloadResponse {
  documentName: string;
  downloadPath: string;
  downloadToken: string;
}

interface DocumentGetDownloadProps {
  abortController?: AbortController;
  documentId: string;
}

const documentGetDownloadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDocumentGetDownload: builder.query<DocumentGetDownloadResponse, DocumentGetDownloadProps>({
      query: ({ abortController = new AbortController(), documentId }: DocumentGetDownloadProps) => ({
        url: `document/get-download?document_id=${documentId}`,
        method: 'GET',
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in getDocumentGetDownload in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetDocumentGetDownloadQuery } = documentGetDownloadApi;
